import m from 'mithril';
import { readFileSync } from 'fs';
import {trans, has_permission} from "./helpers";

const faChevronLeft = readFileSync(__dirname + "/../public/imgs/icons/chevron-left-solid.svg", "utf8");
const faChevronRight = readFileSync(__dirname + "/../public/imgs/icons/chevron-right-solid.svg", "utf8");
const VerifiedBadge = readFileSync(__dirname + "/../public/imgs/icons/ijf_verified_badge.svg", "utf8");

function slider16_9(items){

    let itemWidth = 0;
    let offsetLeft = 0;
    let sliderOffset = 0;
    let offsetArrowRightHide = 0;
    let touchStartX = null;
    let touchStartY = null;
    let touchStartOffsetLeft = 0;
    let touchXSpeed = 0;
    let touchStartXTs = null;
    let touchStartItemNb = null;
    let screenWidth = 0;
    let itemsPerPage = 4;
    let itemOffset = 0;
    let itemsStyle = {
        "transform": "translateX(" + sliderOffset + "px)"
    }

    // TODO
    let show_check = false;

    items = items.map(item => {
        if (item.ends_at) {
            let ends_at_date = new Date(item.ends_at);
            let now_date = new Date();

            if (ends_at_date > now_date) {
                let date_diff = ends_at_date - now_date;
                let days_till_end = Math.ceil(date_diff / (1000 * 3600 * 24));

                item['days_till_end_string'] = days_till_end;

                if (days_till_end > 1)
                    item['days_till_end_string'] += ' ' + trans('common.days');
                
                if (days_till_end == 1)
                    item['days_till_end_string'] += ' ' + trans('common.day');
            } else {
                item['is_past'] = true;
            }
        }

        return item;
    });

    return {
        oncreate : function(vnode){
            itemWidth = vnode.dom.querySelector('.item').offsetWidth
            offsetLeft = vnode.dom.querySelector('.slider__container').offsetWidth;
            offsetArrowRightHide = items.length * itemWidth * -1;
            screenWidth = window.screen.width;
            if(screenWidth > 1200){
                itemsPerPage = 4;
            }else if(screenWidth > 800){
                itemsPerPage = 3;
            }else{
                itemsPerPage = 1;
            }
            m.redraw()
        },
        view : function(vnode){

            itemsStyle['transform'] = "transform: translateX(" + sliderOffset + "px)"

            return m('div.slider__outer-container', {
                /*ontouchstart : function(e){
                    touchStartX = e.touches[0].clientX
                    touchStartY = e.touches[0].clientY
                    touchStartOffsetLeft = sliderOffset
                    touchStartItemNb = Math.abs(Math.round(sliderOffset / itemWidth))
                    touchStartXTs = Date.now()
                    itemsStyle['transition'] = 'transition: none'
                },
                ontouchmove : function(e){
                    if(touchStartY - e.touches[0].clientY < 40){
                        sliderOffset = touchStartOffsetLeft - (touchStartX - e.touches[0].clientX)
                    }else{
                        sliderOffset = touchStartOffsetLeft
                    }
                },
                ontouchend : function(e){
                    if(sliderOffset > 0){
                        sliderOffset = 0
                    }
                    let currentDiffPx = touchStartOffsetLeft - sliderOffset;
                    let item_nb = Math.abs(Math.round(sliderOffset / itemWidth))
                    item_nb += Math.floor(touchXSpeed)
                    if(touchStartItemNb == item_nb){
                        if(Math.abs(currentDiffPx) > 100){
                            if(currentDiffPx < 0){
                                item_nb--;
                            }else{
                                item_nb++;
                            }
                        }
                    }
                    //  console.log(item_nb, items.length)
                    if(item_nb < 0){
                        item_nb = 0;
                    }else if(item_nb >= items.length){
                        item_nb = items.length-1;
                    }
                    sliderOffset = -1 * (item_nb * (itemWidth+20))
                    delete itemsStyle['transition']
                }*/
            },[
                m('div.slider__container',
                    m("ol.slider__items", {
                            "style": Object.values(itemsStyle).join(';') + ';'
                        },
                        items.map(function(__item){
                            return m("a.item",
                                {
                                    href: __item.view_href
                                },
                                [
                                    m("div.item__image",
                                        [
                                            show_check &&
                                            m('.item__image__top-left', 
                                                m('.item__checked')
                                            ),

                                            (__item.required == 1 && !show_check) &&
                                            m('.item__image__top-left', 
                                                m('.item__required', trans('common.required'))
                                            ),

                                            (__item.ends_at && !__item.is_past) &&
                                            m('.item__image__top-right', 
                                                m('.item__counter', [
                                                    m('img.item__counter__icon', {
                                                        src: '/imgs/icons/clock-solid.svg'
                                                    }),
                                                    m('.item__counter__text', __item.days_till_end_string)
                                                ])
                                            ),

                                            __item.subtitle &&
                                            m('.item__image__bottom-left', 
                                                m('.item__author', [
                                                    // m('.avatar.avatar--medium.avatar--white-border',
                                                    //     m('img', {
                                                    //         src: '/imgs/planica_avatar.jpg'
                                                    //     }),
                                                    // ),
                                                    m('.item__author__name', __item.subtitle)
                                                ])
                                            ),

                                            __item.total_users &&
                                            m('.item__image__bottom-right', 
                                                m('.item__counter', [
                                                    m('img.item__counter__icon', {
                                                        src: '/imgs/icons/user-solid.svg'
                                                    }),
                                                    m('.item__counter__number', __item.total_users)
                                                ])
                                            ),

                                            m("div.item__image__background" + (__item.is_past ? '.item__image__background__past' : ''),
                                                m("img", {
                                                    src : __item.url_poster ? __item.url_poster : 'https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/up/2020/05/default_exercise_image-1588937-1588937910.jpg'
                                                })
                                            )
                                        ]
                                    ),
                                    m("div.item__texts",
                                        m("div.item__title",
                                            __item.title
                                        )
                                    )
                                ]
                            )
                        })
                    )
                ),
                itemOffset > 1 && m('div.slider__left-button', {
                    onclick : function(){
                        // sliderOffset += (itemsPerPage*(itemWidth+20)) // document.documentElement.clientWidth - offsetLeft;
                        itemOffset -= itemsPerPage;
                        sliderOffset = (itemOffset* -1 *(itemWidth+20))
                    }
                }, m.trust(faChevronLeft)),
                itemOffset < (items.length - itemsPerPage) && m('div.slider__right-button', {
                    onclick : function(){
                        // sliderOffset -= (itemsPerPage*(itemWidth+20)) // document.documentElement.clientWidth - offsetLeft;
                        itemOffset += itemsPerPage;
                        sliderOffset = (itemOffset* -1 *(itemWidth+20))
                    }
                }, m.trust(faChevronRight))
            ])
        }
    }
}

export default slider16_9;
